<template>
    <div class="relative">
        <draggable :list="estimate.dayworkRates" draggable=".draggable" handle=".handle"
                   @change="estimate.update(); estimate.addSnapshot(); resizeElements();">
            <estimate-daywork-rates-item v-for="(item,index) in estimate.dayworkRates" :key="uuid()" ref="dayworkRates"
                                         :item="item"
                                         :estimate="estimate"
                                         @reflow="resizeElements"
                                         :store="store"
            ></estimate-daywork-rates-item>
        </draggable>

        <!-- New Item. -->
        <div class="flex items-center mt-4 mb-1" v-if="!estimate.readonly">
            <div class="w-6 flex-shrink-0">
                <i class="fa fa-plus text-sm text-gray-400 pl-1"></i>
            </div>
            <div class="flex-1">
                <input
                    placeholder="Add a new daywork rate..."
                    class="text-sm -ml-px -my-px px-2 py-1.5 border-white font-bold text-gray-900 shadow-none relative hover:z-10 focus:z-20 resize-none bg-white"
                    type="text"
                    :disabled="estimate.readonly"
                    v-model="newDayworkRate.description"
                    @input="addDayworkRate('description')"
                >
            </div>
            <div class="w-6 flex-shrink-0 self-start pt-2 -my-px pl-1 pr-1">
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import {Estimate} from "../../../models";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import * as math from "mathjs";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import PageCell from "../../ui/PageCell.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import estimate from "./Estimate.vue";
import EstimateDayworkRatesItem from "./EstimateDayworkRatesItem.vue";
import {uuid} from "../../../utils";

export default {
    components: {
        EstimateDayworkRatesItem,
        UiDropdown,
        PageCell,
        UiDropdownDivider,
        UiDropdownItem,
        draggable,
    },
    props: {
        estimate: Estimate,
        user: Object,
        store: Object,
    },
    data() {
        return {
            newDayworkRate: {
                description: null,
            },
            disableScroller: false,
            scrollPosition: false,
            originalScrollPosition: false,
            scrollTimer: false,
            dayworkRates: estimate.dayworkRates,
        }
    },
    watch: {
        estimate: {
            handler(newValue, oldValue) {
                this.dayworkRates = this.estimate.dayworkRates
                this.resizeElements()
            },
        },
    },
    computed: {},
    methods: {
        uuid,
        resizeElements(forceRedraw) {
            this.dayworkRates = this.estimate.dayworkRates
            this.$nextTick(() => {
                if (this.$refs['dayworkRates']) {
                    this.$refs['dayworkRates'].forEach((dayworkRate) => {
                        if (dayworkRate.$refs['items']) {
                            dayworkRate.$refs['items'].forEach((item) => {
                                if (item.$refs['autoresizable-description']) {
                                    item.$refs['autoresizable-description'].resizeTextarea({target: item.$refs['autoresizable-description'].$el})
                                }
                            })
                        }
                    })
                }
                this.setIsInView()
            })
        },
        round(a, b) {
            if (a) {
                return math.round(a, 0 + b);
            }
            return 0;
        },
        addDayworkRate(trigger) {
            this.estimate.dayworkRates.push({
                description: this.newDayworkRate.description,
                unit: '',
                rate: 0,
            });
            this.$nextTick(() => {
                this.newDayworkRate.description = ''
                this.estimate.update()
                this.$nextTick(() => {
                    this.$refs.dayworkRates[this.$refs.dayworkRates.length - 1].$refs.description.focus()
                })
            })
        },
        setIsInView() {
            let currentScroll = this.scrollPosition;
            let currentTop = document.getElementById('ui-crud-main-body').getBoundingClientRect().top + currentScroll
            let currentBottom = currentTop + document.getElementById('ui-crud-main-body').getBoundingClientRect().height;
            let added = 0;
            let removed = 0;
            if (this.$refs['dayworkRates']) {
                this.$refs['dayworkRates'].forEach((dayworkRate) => {
                    if (dayworkRate.$refs['items']) {
                        dayworkRate.$refs['items'].forEach((item) => {
                            let p = item.$el.getBoundingClientRect();
                            this.distance = {top: p.top + currentScroll, bottom: p.bottom + currentScroll}
                            let inView = (this.distance.top < (currentBottom + 2)) && (this.distance.bottom > (currentTop + 2));
                            item.setIsInView(inView)
                        })
                    }
                })
            }
        },
        scroller() {
            this.scrollPosition = document.getElementById('ui-crud-main-body').scrollTop;
            clearTimeout(this.scrollTimer);
            this.scrollTimer = setTimeout(() => {
                if (!this.disableScroller) {
                    this.disableScroller = true;
                    this.$nextTick(() => {
                        this.setIsInView()
                        this.$nextTick(() => {
                            document.getElementById('ui-crud-main-body').scrollTo({top: this.scrollPosition})
                            this.disableScroller = false;
                        })
                    })
                }
            }, 50)
        },
    },
    mounted() {
        window.addEventListener('scroll', this.scroller, true);
        this.$nextTick(() => {
            this.setIsInView()
        })
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.scroller, true)
    },
}
</script>
